module.exports = __webpack_public_path__ + "img/map-contatti-mobile.7b11e14d.png";